import {CancellationService} from '../../../services/cancellation.service';
import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material';
import {MatDialogRef} from '@angular/material/dialog';
import {Router} from '@angular/router';
import {ToastMessagesService} from '../../../services/toast-messages.service';

interface CancellationReason {
  id: number;
  description: string;
  refers_to: any;
}

interface CancelAction {
  id: number;
  description: string;
}

@Component({
  templateUrl: 'cancellation-material-dialog.component.html'
})

export class CancellationMaterialDialogComponent implements OnInit {
  actions: CancelAction[] = [];
  commandId: number;
  isLoading: boolean;
  orderId: number;
  orderTypeId: number;
  reasons: CancellationReason[] = [];
  rowId: number;
  selectedAction: CancelAction;
  selectedReason: CancellationReason;
  title: string;

  constructor(private cancellationService: CancellationService,
              private matDialogRef: MatDialogRef<CancellationMaterialDialogComponent>,
              private router: Router,
              private toastMessagesService: ToastMessagesService,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    this.title = 'Ακύρωση κωδικού είδους';
    this.rowId = this.data.row_id;
    this.commandId = this.data.command_id;
    this.orderTypeId = this.data.order_type_id;
    this.isLoading = false;
  }

  public async ngOnInit(): Promise<any> {
    try {
      this.reasons = await this.cancellationService.getCancelReasons('refers_to=1');
      this.actions = this.orderTypeId === 2 ?
        await this.cancellationService.getCancelActions('(id=2 OR id=3)') : [];
    } catch (e) {
      this.toastMessagesService.toastErrorMessage('Δεν μπορέσαμε να φέρουμε τις αιτίες ακύρωσης');
    }
  }

  close(value?: boolean) {
    this.matDialogRef.close(value);
  }

  async cancel() {
    try {
      this.isLoading = true;
      const model = {
        cancel_reason_id: this.selectedReason.id,
        command_id: this.commandId,
        request_result_id: this.orderTypeId === 2 ? this.selectedAction.id : null,
        row_id: this.rowId
      };
      await this.cancellationService.cancelLoadingOrderMaterial(model);
      this.close(true);
    } catch (e) {
      this.isLoading = false;
      this.toastMessagesService.toastErrorMessage('Δεν μπορέσαμε να ακυρώσουμε τον κωδικό');
    }
  }


  //#region helper methods
  isButtonDisabled() {
    if (this.orderTypeId === 1) {
      return !this.selectedReason;
    }

    if (this.orderTypeId === 2) {
      return !(this.selectedReason && this.selectedAction);
    }
  }
  //#endregion
}
